import { ElementMixin } from '@polymer/polymer/lib/mixins/element-mixin';

export class AnimationManager {
  constructor(polymerElement) {
    this.polymerElement = polymerElement;
    this.registry = {};
  }

  register(elem, config) {
    if (elem == null) return;
    config = config || {};
    // Setup observer function.
    let inlineStyles = JSON.parse(JSON.stringify(elem.style));
    let observerName = `animationManager_${config.id || elem.id}`;
    this.polymerElement[observerName] = async (...args) => {
      let newStyle = {};
      config.rules.forEach((rule) => {
        if ((typeof rule.if === 'function' && rule.if(...args)) || (typeof rule.if !== 'function' && rule.if)) {
          for (let prop in rule.style) {
            if (prop == '$invisible') {
              if (rule.style[prop]) {
                newStyle.opacity = 0;
                newStyle.pointerEvents = 'none';
              } else {
                newStyle.opacity = 1;
                newStyle.pointerEvents = '';
              }
            } else if (prop == '$hidden') {
              if (rule.style[prop]) {
                newStyle.display = 'none';
              } else {
                newStyle.display = inlineStyles.display || '';
              }
            } else {
              if (typeof rule.style[prop] === 'function') {
                newStyle[prop] = rule.style[prop](elem);
              } else {
                newStyle[prop] = rule.style[prop];
              }
            }
          }
        }
      });
      if (newStyle.display != null) {
        elem.style.display = newStyle.display;
        await new Promise((x) => setTimeout(x));
      }
      for (let prop in newStyle) elem.style[prop] = newStyle[prop];
    };
    // Call observer once to set default style.
    this.polymerElement[observerName]();
    // Setup transition.
    setTimeout(() => (elem.style.transition = 'all 0.3s'));
    // Attach observer function.
    this.polymerElement._createMethodObserver(`${observerName}(${config.observer})`, true);
  }
}
